import React, { useEffect, useState } from 'react';
import './GovtTaxTileContent.css';
import { Grid } from '@mui/material';
import { fonts, themes } from '../../themes/themes';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
interface contentTileType {
  taxName?: string;
  taxFor?: string;
  taxValue?: number;
  taxType?: number;
  salaryFrom?: any;
  salaryTo?: any;
  taxApplicables?: any;
  currency?: any;
}
const GovtTaxTileContent: React.FC<contentTileType> = ({
  salaryFrom,
  salaryTo,
  taxFor,
  taxName,
  taxType,
  taxApplicables,
  taxValue,
  currency,
}) => {
  const allowances = _.map(taxApplicables, 'allowance_type.name');
  const { t } = useTranslation();
  const trans = t;
  return (
    <Grid container className="govtTax-container">
      <Grid
        item
        xs={12}
        style={{
          fontSize: fonts.title,
          fontFamily: fonts.fontFamily,
          color: themes.blackDefault,
          fontWeight: 'bold',
          textTransform: 'capitalize',
          display: 'flex',
        }}
      >
        {taxName}
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: themes.defaultIcon,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          textTransform: 'capitalize',
          letterSpacing: '0.01px',
          marginTop: '10px',
        }}
      >
        {trans('Tax For')}:{' '}
        <span style={{ color: themes.blackDefault }}>{taxFor}</span>
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: themes.defaultIcon,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          letterSpacing: '0.01px',
          marginTop: '2px',
          textTransform: 'capitalize',
        }}
      >
        {trans('Value')}:{' '}
        <span style={{ color: themes.blackDefault }}>
          {taxType == 0 ? `${taxValue}%` : taxValue}
        </span>{' '}
        | {trans('Salary Range')} :{' '}
        <span
          style={{ color: themes.blackDefault }}
        >{`${currency} (${salaryFrom} - ${salaryTo})`}</span>
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: themes.defaultIcon,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          letterSpacing: '0.01px',
          marginTop: '2px',
          textTransform: 'capitalize',
        }}
      >
        {trans('Applicable for')} : {allowances?.toString()}
      </Grid>
    </Grid>
  );
};

export default GovtTaxTileContent;
